export const renderFlagIconRound = countryCode => {
  const icons = {
    US:
      'https://cdn.shippingcart.com/assets/flag-round-shadow-us-20210915110953.svg',
    UK:
      'https://cdn.shippingcart.com/assets/flag-round-shadow-uk-20210915111000.svg',
    AU:
      'https://cdn.shippingcart.com/assets/flag-round-shadow-au-20210915111007.svg',
    KR:
      'https://cdn.shippingcart.com/assets/flag-round-shadow-kr-20210915111013.svg',
    PH:
      'https://cdn.shippingcart.com/assets/flag-round-shadow-ph-20210915111020.svg',
    MY:
      'https://cdn.shippingcart.com/assets/flag-round-shadow-my-20210915111027.svg',
    JP:
      'https://cdn.shippingcart.com/assets/flag-round-shadow-jp-20211117050029.svg',
    default:
      'https://cdn.shippingcart.com/assets/flag-round-shadow-us-20210915110953.svg',
  };

  return icons[convertCountryIDToCode(countryCode)] || icons.default;
};

export const renderFlagSquareSmall = countryCode => {
  const icons = {
    US:
      'https://cdn.shippingcart.com/assets/flag-full-shadow-small-us-20220628101526.svg',
    UK:
      'https://cdn.shippingcart.com/assets/flag-full-shadow-small-uk-20220628101526.svg',
    AU:
      'https://cdn.shippingcart.com/assets/flag-full-shadow-small-au-20220628101526.svg',
    KR:
      'https://cdn.shippingcart.com/assets/flag-full-shadow-small-kr-20220628101526.svg',
    JP:
      'https://cdn.shippingcart.com/assets/flag-full-shadow-small-jp-20220628101526.svg',
    default:
      'https://cdn.shippingcart.com/assets/flag-full-shadow-small-us-20220628101526.svg',
  };

  return icons[convertCountryIDToCode(countryCode)] || icons.default;
};

const convertCountryIDToCode = value => {
  switch (value) {
    case 1:
      return 'US';
    case 2:
      return 'UK';
    case 3:
      return 'AU';
    case 4:
      return 'KR';
    case 5:
      return 'JP';
    default:
      return value;
  }
}


export const warehouseIDToCode = value => {
  switch (value) {
    case 1:
      return 'us';
    case 2:
      return 'uk';
    case 3:
      return 'au';
    case 4:
      return 'kr';
    case 5:
      return 'jp';
    case 6:
      return 'or';
    default:
      return value;
  }
}



/** WEBPACK FOOTER **
 ** ./src/utils/warehouseFlags.js
 **/